<template>
  <div class="version-name">
    {{ bookVersionName(books) }}
  </div>
</template>
<script>
import { getUserBookVersionName } from '@/static/js/business'
export default {
  name: 'VersionName',
  props: {
    // 图书版本
    books: {
      type: Object,
      default: () => ({})
    },
    // 是否为分类页（特殊处理）
    isCate: {
      type: Boolean,
      default: false
    },
    // 是否为页码页（特殊处理）
    length: {
      type: [Number, null],
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    // 图书版本
    bookVersionName() {
      return (data) => getUserBookVersionName(data, this.isCate, this.length)
    }
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped></style>
